export enum SearchDocumentSortBy {
    Title = "title",
    Type = "category",
    Date = "createdDate",
}

export enum DocumentSearchConstants {
    NumberOfResultsPerPage = 20,
    SearchValidLength = 3,
    SearchDebounceTime = 500,
}

export enum DocumentsAndFormsTableColumns {
    date = "date",
}

export const DocumentsAndFormsTableName = "documentsAndFormsTable";

export enum DocumentSearchResultsTableHeader {
    Title = "title",
    Type = "category",
    Date = "createdDate",
    Download = "download",
}
